import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { REGISTRATION_WITH_BANK_ID_ACTION_TYPE } from "../../../sdk/registration/bank-id/registration-with-bank-id.action";

import { RegistrationWithBankIdState } from "./registration-with-bank-id.model";

const INITIAL_STATE: RegistrationWithBankIdState = {
	getBankIdEndpointUrlSuccess: undefined,
	bankIdEndpointUrl: undefined,
};

export function registrationWithBankIdReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): RegistrationWithBankIdState {
	switch (action.type) {
		case REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrl: {
			return updateState(state, {
				getBankIdEndpointUrlSuccess: undefined,
				bankIdEndpointUrl: undefined,
			});
		}

		case REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrlSuccess: {
			return updateState(state, {
				getBankIdEndpointUrlSuccess: true,
				bankIdEndpointUrl: action.payload,
			});
		}

		case REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrlFail: {
			return updateState(state, {
				getBankIdEndpointUrlSuccess: false,
				bankIdEndpointUrl: undefined,
			});
		}

		default:
			return state;
	}
}
